module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', {}, [_vm._v("Calendar"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('See all Portal related events, with filters'),
      expression: "'See all Portal related events, with filters'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "calendar-wrapper"
  }, [_c('div', {
    staticClass: "calendar-filters"
  }, [_c('ul', [_c('li', [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    on: {
      "change": function($event) {
        _vm.filterEvents($event, 'assignment')
      }
    }
  }), _vm._v("Assignments")])]), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    on: {
      "change": function($event) {
        _vm.filterEvents($event, 'meeting')
      }
    }
  }), _vm._v("Meetings")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear-me"
  }), _vm._v(" "), (_vm.events) ? _c('full-calendar', {
    key: _vm.key,
    ref: "calendar",
    attrs: {
      "header": _vm.calendarHeader,
      "selectable": false,
      "editable": false,
      "events": _vm.events,
      "config": _vm.config
    },
    on: {
      "event-selected": _vm.selectEvent
    }
  }) : _c('div', {
    staticClass: "loader"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dfb05530!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendar.vue
// module id = 2110
// module chunks = 2